'use strict';
import Swiper from 'swiper/bundle';

/**
 * @classname swiper
 * @classdesc スライダー
 */
export default class swiper {
	/**
	 * @constructor
	 * @param {jQuery} $e - .swiper
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		const no = $e.attr('data-slider-type');
		const options = this.getSliderOptions(no);
		this._swiper = new Swiper(this._$e[0], options);
	};


	/**
	 * sliderTypeを取得する
	 *
	 * @memberof swiper
	 * @param {string} no - sliderType
	 * @return {object} options - swiper option
	 */
	getSliderOptions(no) {
		console.log(`${this.constructor.name}.getSliderOptions`);
		let options = {};
		switch(no){
			case '1':
				options = {
					pagination: {
						el: '.swiper-pagination',
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					breakpoints: {
						320: {
							spaceBetween: 20,
							slidesPerView: 2,
						},
						992: {
							spaceBetween: 20,
							slidesPerView: 4
						},
						1200: {
							spaceBetween: 40,
							slidesPerView: 4
						}
					}
				}
				break;
			case '2':
				options = {
					spaceBetween: 10,
					slidesPerView: '5',
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					breakpoints: {
						320: {
							spaceBetween: 10,
							slidesPerView: 5,
						},
						992: {
							spaceBetween: 14,
							slidesPerView: 10
						},
						1200: {
							spaceBetween: 14,
							slidesPerView: 10
						}
					}
				};
				break;
			case '3':
				options = {
					pagination: {
						el: '.swiper-pagination',
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					breakpoints: {
						320: {
							spaceBetween: 20,
							slidesPerView: 2,
						},
						992: {
							spaceBetween: 20,
							slidesPerView: 5
						},
						1200: {
							spaceBetween: 40,
							slidesPerView: 5
						}
					}
				}
				break;
			case '4':
				options = {
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					slidesPerView: 'auto',
					loop: true,
					autoplay: {
						delay: 3500,
						disableOnInteraction: false,
					},
				}
				break;
			case '5':
				options = {
					pagination: {
						el: '.swiper-pagination',
					},
					slidesPerView: 'auto',
					spaceBetween: 10,
					loop: true,
					loopedSlides: 5
				}
				break;
		}
		return options;
	};
};
